import gql from 'graphql-tag';
import { TypedDocumentNode } from '@apollo/client';

import {
  DefaultArg,
  DefaultApiResponse,
  transactionErrorFragment,
} from '@libs/graphql';
import { TransactionAmountType } from '@libs/backend-common';

import { TransactionErrorResponse } from 'src/types';

export type CalculateDirectCrypto = {
  fromAssetAmount: number;
  fromAssetAmountNoFee?: number;
  toAssetAmount: number;
  toAssetAmountNoFee?: number;
  rate: number;
  feeRate: number;
  exchangeFeeId?: number;
  disableReset?: boolean;
  error?: TransactionErrorResponse;
  feeAmount?: string;
};
export type CalculateDirectCryotoArgs = {
  amount: number;
  type: TransactionAmountType;
  fromAssetCode: string;
  toAssetCode: string;
};

export type CalculateDirectCryptoResponse = {
  calculateDirectCrypto: DefaultApiResponse<CalculateDirectCrypto>;
};

export const calculateDirectCryptoQuery: TypedDocumentNode<
  CalculateDirectCryptoResponse,
  DefaultArg<CalculateDirectCryotoArgs>
> = gql`
  query CalculateDirectCrypto($record: CalculateExchangeRecord!) {
    calculateDirectCrypto(record: $record) {
      fromAssetAmount
      fromAssetAmountNoFee
      disableReset
      toAssetAmount
      toAssetAmountNoFee
      rate
      exchangeFeeId
      feeAmount
      feeRate
      error {
        ...transactionErrorFields
      }
    }
  }
  ${transactionErrorFragment}
`;
